var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarriedIconFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C6.46957 2 5.96086 2.21071 5.58579 2.58579C5.21071 2.96086 5 3.46957 5 4C5 4.53043 5.21071 5.03914 5.58579 5.41421C5.96086 5.78929 6.46957 6 7 6C7.53043 6 8.03914 5.78929 8.41421 5.41421C8.78929 5.03914 9 4.53043 9 4C9 3.46957 8.78929 2.96086 8.41421 2.58579C8.03914 2.21071 7.53043 2 7 2ZM16 2C15.4696 2 14.9609 2.21071 14.5858 2.58579C14.2107 2.96086 14 3.46957 14 4C14 4.53043 14.2107 5.03914 14.5858 5.41421C14.9609 5.78929 15.4696 6 16 6C16.5304 6 17.0391 5.78929 17.4142 5.41421C17.7893 5.03914 18 4.53043 18 4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2ZM5 7C3.895 7 3 7.895 3 9V15C3 15.552 3.448 16 4 16V21C4 21.552 4.448 22 5 22C5.552 22 6 21.552 6 21V16H8V21C8 21.552 8.448 22 9 22C9.552 22 10 21.552 10 21V16C10.552 16 11 15.552 11 15V9C11 7.895 10.105 7 9 7H5ZM14.9844 7C14.0184 7 13.1886 7.69158 13.0156 8.64258L11.7285 17.0742C11.6545 17.5612 12.0314 18 12.5234 18H13V21C13 21.552 13.448 22 14 22C14.552 22 15 21.552 15 21V18H17V21C17 21.552 17.448 22 18 22C18.552 22 19 21.552 19 21V18H19.5176C20.0116 18 20.3865 17.5593 20.3105 17.0723L18.9844 8.64258C18.8104 7.69158 17.9816 7 17.0156 7H14.9844Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarriedIconFigma);
export default __webpack_public_path__ + "static/media/married-icon-figma.9fc85fb07822a8f8c3acf595dfe24777.svg";
export { ForwardRef as ReactComponent };